import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import WDialog from "@/components/wrappers/w-dialog.vue";
import WTinyMce from "@/components/wrappers/w-tiny-mce.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
let SpeachHtmlTranslationDialog = class SpeachHtmlTranslationDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "tKey", void 0);
    _defineProperty(this, "sourceHtml", void 0);
    _defineProperty(this, "initialHtml", void 0);
    _defineProperty(this, "originalLangLabel", void 0);
    _defineProperty(this, "targetLangLabel", void 0);
    _defineProperty(this, "saving", void 0);
    _defineProperty(this, "currentHtml", '');
    // Must be a reactive field (not a computed): w-tiny-mce only builds its initConfig in updated()
    // when customConfig becomes non-null after mount.
    _defineProperty(this, "editorConfig", null);
  }
  mounted() {
    this.currentHtml = this.initialHtml || '';
    // Destroy any leftover TinyMCE instance with the same id, then trigger the reactive change
    // that w-tiny-mce listens for to initialise its internal config.
    window?.tinymce?.get(this.editorId)?.destroy();
    this.$nextTick(() => {
      this.editorConfig = {
        plugins: 'lists advlist code preview link media code codesample table accordion',
        toolbar: 'undo redo | bold italic underline strikethrough hr | fontfamily blocks forecolor backcolor removeformat | bullist numlist outdent indent align | customimageupload media table | customchecklist accordion flipcard | custombutton link codesample lgit ink | code',
        media_live_embeds: true,
        height: 320
      };
    });
  }
  onInitialHtmlChange(value) {
    this.currentHtml = value || '';
  }
  get editorId() {
    return `html-translation-editor-${this.tKey}`;
  }
  /**
   * w-tiny-mce emits the editor's current HTML on blur — we capture every change
   * so the latest content is held in {@link currentHtml} when the user clicks SAVE.
   */
  onEditorContent(html) {
    this.currentHtml = html != null ? html : '';
  }
  onSave() {
    this.$emit('save', this.currentHtml);
  }
  onCancel() {
    this.$emit('close');
  }
};
__decorate([Prop({
  required: true
})], SpeachHtmlTranslationDialog.prototype, "visible", void 0);
__decorate([Prop({
  required: true
})], SpeachHtmlTranslationDialog.prototype, "tKey", void 0);
__decorate([Prop({
  default: ''
})], SpeachHtmlTranslationDialog.prototype, "sourceHtml", void 0);
__decorate([Prop({
  default: ''
})], SpeachHtmlTranslationDialog.prototype, "initialHtml", void 0);
__decorate([Prop({
  default: ''
})], SpeachHtmlTranslationDialog.prototype, "originalLangLabel", void 0);
__decorate([Prop({
  default: ''
})], SpeachHtmlTranslationDialog.prototype, "targetLangLabel", void 0);
__decorate([Prop({
  default: false
})], SpeachHtmlTranslationDialog.prototype, "saving", void 0);
__decorate([Watch('initialHtml')], SpeachHtmlTranslationDialog.prototype, "onInitialHtmlChange", null);
SpeachHtmlTranslationDialog = __decorate([Component({
  components: {
    WDialog,
    WTinyMce,
    StandardButton
  },
  emits: ["save", "close"]
})], SpeachHtmlTranslationDialog);
export default SpeachHtmlTranslationDialog;